import { render, staticRenderFns } from "./FormatGroupTab.vue?vue&type=template&id=eabdfad4&"
import script from "./FormatGroupTab.vue?vue&type=script&lang=ts&"
export * from "./FormatGroupTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports